import { Tab } from 'bootstrap'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { v4 } from 'uuid';
import {
	MenuComponent,
	DrawerComponent,
	ScrollComponent,
	ScrollTopComponent,
	StickyComponent,
	ToggleComponent,
	SwapperComponent,
} from '../assets/ts/components'
import { ThemeModeComponent } from '../assets/ts/layout'
import { useLayout } from './core'
import { saveDeviceToken } from '../../redux/features/auth-slice';
import { getCountries } from '../../redux/apis/commonAPIs';
import { useTranslation } from 'react-i18next'
import { useDynamicStyleSheet } from '../../hooks/useDynamicStyleSheet'

export function MasterInit() {
	const { i18n } = useTranslation();
	const dir = i18n.dir();
	const deviceToken = useSelector((state: any) => state.auth.deviceToken);
	const selectedLang = useSelector((state: any) => state.auth.selectedLanguage);
	useDynamicStyleSheet(selectedLang?.rtl ? 'rtl' : 'ltr');
	const dispatch = useDispatch();
	const { config } = useLayout()
	const isFirstRun = useRef(true)
	const pluginsInitialization = () => {
		isFirstRun.current = false
		ThemeModeComponent.init()
		setTimeout(() => {
			ToggleComponent.bootstrap()
			ScrollTopComponent.bootstrap()
			DrawerComponent.bootstrap()
			StickyComponent.bootstrap()
			MenuComponent.bootstrap()
			ScrollComponent.bootstrap()
			SwapperComponent.bootstrap()
			document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
				Tab.getOrCreateInstance(tab)
			})
		}, 500)
	}

	useEffect(() => {
		if (isFirstRun.current) {
			isFirstRun.current = false
			pluginsInitialization()
		}
	}, [config])

	useEffect(() => {
		if (deviceToken === null || deviceToken === '' || deviceToken === undefined) {
			const uuid:any = v4();
			dispatch(saveDeviceToken(uuid));
		}
		dispatch(getCountries());
	}, []);

	return <></>
}
